import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../Buttons/ButtonBase';
import { CEL_TYPE, CONTACT_SOURCE } from '../../utils/ConstantsMain';
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  TextField,
  Grid,
  Button,
} from '@material-ui/core';
import "./addNewContacts.scss";

const styles = () => ({
  form: {
    padding: 24,
    borderRadius: 4,
    margin: '20px 0 30px 0',
    border: '1px solid #e7e7e7',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 568,
  },
  firstForm: {
    padding: 24,
    borderRadius: 4,
    //margin: '0px 0 30px 0',
    border: '1px solid #e7e7e7',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 568,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  TextField: {
    margin: '0 16px 6px 0',
    width: '100%',
    maxWidth: 512,
  },
  TextFieldLeft: {
    maxWidth: 248,
    margin: '0 16px 6px 0',
    width: '100%',
  },
  TextFieldRight: {
    maxWidth: 248,
    margin: '0 0 6px 0',
    width: '100%',
  },
  paragraph: {
    color: '#484848',
    fontSize: 14,
    margin: '0 0 25px'
  },
  deleteActionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  deleteAction: {
    color: '#d74242',
    fontSize: 12,
    padding: 0,
    textTransform: 'capitalize',
    margin: '0 30px 0 0',
  },
});

const LawyerNewContactsForm = props => {

  const {
    newContact,
    newContactsHelper,
    handleCancel,
    handleChange,
    handleBlur,  
    touched,
    errors,
    isValid,
    classes,
    index,
  } = props;

  const deleteSubForm = () => {
    newContactsHelper.remove(index)
  };

  return (
    <div
      className={
        index && index !== 0 ?
        classes.form : classes.firstForm
      }
    >
      <p className={classes.paragraph}>
        Para guardar un contacto es necesario registrar el número telefónico o el email
      </p>

        <TextField
          label="Nombre completo*"
          name={`newContacts[${index}].fullName`}
          id="fullName"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={newContact && newContact.fullName ? newContact.fullName : ''}
          helperText={
            touched &&
            touched.newContacts &&
            touched.newContacts[index] &&
            touched.newContacts[index].fullName &&
            errors &&
            errors.newContacts &&
            errors.newContacts[index] &&
            errors.newContacts[index].fullName ?
            errors.newContacts[index].fullName :
            ''
          }
          error={
            touched &&
            touched.newContacts &&
            touched.newContacts[index] &&
            touched.newContacts[index].fullName &&
            errors &&
            errors.newContacts &&
            errors.newContacts[index] &&
            errors.newContacts[index].fullName ?
            true : false
          }
          fullWidth
          classes={{ root: classes.TextField }}
        />

      {/* Grid con Teléfono y tipo de telefono */}

      <Grid container direction='row'>
        <TextField
          label="Teléfono(s)*"
          name={`newContacts[${index}].phone`}
          id="phone"
          type="phone"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={newContact && newContact.phone ? newContact.phone : ''}
          helperText={
            touched &&
            touched.newContacts &&
            touched.newContacts[index] &&
            touched.newContacts[index].phone &&
            errors &&
            errors.newContacts &&
            errors.newContacts[index] &&
            errors.newContacts[index].phone ?
            errors.newContacts[index].phone :
            ''
          }
          error={
            touched &&
            touched.newContacts &&
            touched.newContacts[index] &&
            touched.newContacts[index].phone &&
            errors &&
            errors.newContacts &&
            errors.newContacts[index] &&
            errors.newContacts[index].phone ?
            true : false
          }
          fullWidth
          classes={{ root: classes.TextFieldLeft }}
        />
        
        <FormControl
          classes={{ root: classes.TextFieldRight }}
          variant="outlined"
          error={touched.typePhone && errors.typePhone ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Tipo de teléfono'}
          </InputLabel> 
            <Select
              id='typePhone'
              name={`newContacts[${index}].typePhone`}
              value={newContact && newContact.typePhone ? newContact.typePhone : []}
              onChange={handleChange}
            >
              {CEL_TYPE && CEL_TYPE.map((item, index) => (
                <MenuItem key={index} value={item.value} >
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched &&
          touched.newContacts &&
          touched.newContacts[index] &&
          touched.newContacts[index].typePhone &&
          errors &&
          errors.newContacts &&
          errors.newContacts[index].typePhone ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.newContacts[index].typePhone}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>
      </Grid>

      {/* Grid con Email y Fuente de contacto */}

      <Grid container direction='row'>
        <TextField
          label="Email"
          name={`newContacts[${index}].email`}
          id="email"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={newContact && newContact.email ? newContact.email : ''}
          helperText={
            touched &&
            touched.newContacts &&
            touched.newContacts[index] &&
            touched.newContacts[index].email &&
            errors &&
            errors.newContacts &&
            errors.newContacts[index] &&
            errors.newContacts[index].email ?
            errors.newContacts[index].email :
            ''
          }
          error={
            touched &&
            touched.newContacts &&
            touched.newContacts[index] &&
            touched.newContacts[index].email &&
            errors &&
            errors.newContacts &&
            errors.newContacts[index] &&
            errors.newContacts[index].email ?
            true : false
          }
          fullWidth
          classes={{ root: classes.TextFieldLeft }}
        />
        
        <FormControl
          classes={{ root: classes.TextFieldRight }}
          variant="outlined"
          error={touched.Items && errors.Items ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Fuente de contacto'}
          </InputLabel> 
            <Select
              id='source'
              name={`newContacts[${index}].source`}
              //value={newContact && newContact.source ? newContact.source : []}
              value='Contacta Abogado®'
              onChange={handleChange}
              disabled
            >
              {/* {CONTACT_SOURCE && CONTACT_SOURCE.map((item, index) => (
                <MenuItem key={index} value={item.value} >
                  {item.name}
                </MenuItem>
              ))} */}
              <MenuItem key='Contacta Abogado®' value='Contacta Abogado®' >
                Contacta Abogado®
              </MenuItem>
          </Select>
          {touched &&
          touched.newContacts &&
          touched.newContacts[index] &&
          touched.newContacts[index].source &&
          errors &&
          errors.newContacts &&
          errors.newContacts[index].source ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.newContacts[index].source}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>
      </Grid>

      <div style={{ display: 'flex' }}>
            <ButtonBase
              type="submit"
              //onClick={handleSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase }
              style={{ marginRight: 16}}
              disabled={!isValid}
            >
              Guardar
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>
          </div>
      
      {index && index !== 0 ?
        <div className={classes.deleteActionContainer}>
          <Button
            key={index}
            component="span"
            type="button"
            onClick={index && index !== 0 ? deleteSubForm : handleCancel}
            className={classes.deleteAction}
          >
            Eliminar
          </Button>
        </div> : null
      }
    </div>
  )
};

export default withStyles(styles)(LawyerNewContactsForm);
